import { apiRequest } from "../apiRequest";
import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import { TextField } from "@mui/material";

const defaultLocations = ['Bengaluru', 'Delhi', 'Hyderabad', 'Mumbai', 'Singapore', 'Shanghai', 'Virtual','US']
const defaultCommunities = ['Nambiar Bellezia', 'Sobha Jasmine','Mantri Espana', 'Windmills of the Mind','Kriti Apartments','Soroptomerist International']
const defaultSchools = [ 'GIIS','Basilwood','Vidya Shilpi','Greenwood High School','National Public School', 'Delhi Public School', 'Gear International', 'One World International Sarjapur','One World International Whitefield']
const defaultCompanies = ['Yes Bank','Emmbi','Netskope','Egon Zender','Aziz Premji Foundation','Finnable','Wissen Technology','BYJU','Print Venue']
const defaultOrgs=['Snehasadan','Sandra Ricketts','Sneha Care']

const keyDefaultMapping = {
    'location': defaultLocations,
    'community': defaultCommunities,
    'company': defaultCompanies,
    'school': defaultSchools,
    'college': [],
    'org_name':defaultOrgs
};

export async function fetchKeyValues(model, key) {
    try {
        const values = await apiRequest('GET', null, `/unique_values/${model}/${key}`, null, null, {}, true);
        const combinedValues = [...values.data, ...keyDefaultMapping[key]];
        return combinedValues.sort();
    } catch (err) {
        return keyDefaultMapping[key];
    }
}

export async function fetchAttributeValues({ model, setLocations, setCommunities, setSchools, setCompanies, setColleges, setOrganisations }) {
    if (setLocations) { const apiLocations = await fetchKeyValues(model, 'location'); setLocations(apiLocations); }

    if (setCommunities) { const apiCommunities = await fetchKeyValues(model, 'community'); setCommunities(apiCommunities); }

    if (setSchools) { const apiSchools = await fetchKeyValues(model, 'school'); setSchools(apiSchools); }

    if (setCompanies) { const apiCompanies = await fetchKeyValues(model, 'company'); setCompanies(apiCompanies); }

    if (setColleges) { const apiColleges = await fetchKeyValues(model, 'college'); setColleges(apiColleges); }

    if (setOrganisations) { const apiOrganisations = await fetchKeyValues(model, 'org_name'); setOrganisations(apiOrganisations);
    }
}

export const KeyFillDropDown = ({ options, keyName, formData, updateFormData, handleFormChange, size = 'small', required = false }) => {
    // console.log(options);
    return (
        <Autocomplete
            required={required}
            options={options || ['']}
            getOptionLabel={(option) => option}
            value={formData && formData[keyName] ? formData[keyName] : ''}
            onBlur={(e) => { handleFormChange(e.target.value, keyName, formData, updateFormData); }}
            onChange={(e, value) => { handleFormChange(value, keyName, formData, updateFormData); }}
            renderInput={(params) => (
                <TextField {...params} variant="outlined" size={size} />
            )}
            freeSolo
        />
    );
};








